import NumberAnimation from 'components/NumberAnimation'
import { useAppSelector } from 'src/store/hooks'
import { getSweepstakeCurrencySelector } from 'store/modules/currencies/selectors'

import classes from './styles.module.scss'

function SweepstakeCurrency() {
  const sweepstakeCurrency = useAppSelector(getSweepstakeCurrencySelector)

  if (sweepstakeCurrency) {
    return (
      <div className={`mt-typography-caption ${classes.curencyText}`}>
        <img
          src={`${process.env.IMG_ORIGIN}/sc-icon.png`}
          className={classes.icon}
          alt={'sc icon'}
          width={16}
          height={16}
        />
        <span data-test='header-sweepstakes-value'>
          SC <NumberAnimation amount={sweepstakeCurrency.amount} currency='SC' />
        </span>
      </div>
    )
  }

  return null
}

export default SweepstakeCurrency
